import QuanlychungtuPage from "./QuanlychungtuPage";

export default QuanlychungtuPage;
